import React from "react";
import "./Footer.css";
import { FaFacebookF } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { FaYoutube } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const containerFooter = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  visible: {
    opacity: 1,
    x: "0",
    transition:{
      type:"spring",
      stiffness:120
    }
  },
  hov:{
    scale:1.05
  }
};

const Footer = () => {
  return (
    <div className="footer">
      <motion.div
        className="container container-custom-footer"
        variants={containerFooter}
        initial="hidden"
        animate="visible"
        whileHover="hov"
      >
        <div className="footer-social">
          <span>
            <FaYoutube />
          </span>
          <span>
            <BsTwitter />
          </span>
          <span>
            <BsInstagram />
          </span>
          <span>
            <FaFacebookF />
          </span>
        </div>
        <div className="footer-copyright">
          <Link to="/about">About</Link>
          <h3>Copyright &copy; Text Genuss. All Rights Reserved.</h3>
        </div>
      </motion.div>
    </div>
  );
};

export default Footer;
